module.exports = {
  jobId: "Job Id",
  customerName: "Customer",
  productLine: "Line",
  startUp: "Start-Up",
  warranty: "Warranty",
  feeMonth: "Month",
  feeType: "Type of expense",
  laborCost: "Manpower Cost",
  travelCost: "Travelling Cost",
  partsCost: "Spare Part Cost",
  otherCost: "Others Cost",
  salesFee: "Revenue",
  createTime: "Submit at",
  remark: "Note",
  time: "Time",
  dialogTitle: "财务费用提报",
  cancel: "Cancel",
  confirm: "Confirm",
  submit: "Submit",
  tips: {
    deleteTitle: "Delete",
    deleteMessage: "Confirm Delete",
    validNumberError: "Please enter a number",
    validJobIdError: "Please enter Job ID",
    validFeeMonthError: "Please select month",
    validFeeType: "Please select date",
  },
  constants: {
    feeType: ["Installation", "Warranty", "Out of Warranty"],
  },
};
